<template>
    <div class="nav-margin">
        <navigation></navigation>
        <div
            class="back-btn bg-white border-bottom border-gray-100 d-flex gap-12 justify-content-between flex-wrap gap-2 py-3 px-3">
            <a class="p-0  d-flex align-items-center gap-1 fs-14" href="/jobs">
                <img src="/img/chevron-left-gray.svg" alt="chevron-left" />
                Back
            </a>

            <div class="d-flex align-items-center ">
                <button class="btn btn-link p-1 mb-0" @click="$refs.manageJobModal && $refs.manageJobModal.openWithJob(job)">
                    <img src="/img/pencil-alt.svg" width="16" alt="edit-job-details-icon">
                </button>

                <button class="btn btn-link p-1 mb-0" @click.stop="$refs.deleteJobModal && $refs.deleteJobModal.open(job)">
                    <img src="/img/review/icons/trash.svg" width="16" alt="delete-job-icon">
                </button>
            </div>
        </div>

        <main v-if="!isLoading" class="flex-fill overflow-auto job-details-section">
            <div class="row g-0">
                <div class="px-3 py-32 position-relative w-100">
                    <div class="job-details-container mx-auto">
                        <div class="d-flex flex-column gap-3 job-header">
                            <div>
                                <h6 class=" mb-2 text-gray-500 fs-12 fw-normal">{{ job.jobNumber }}</h6>
                                <h1 class="text-gray-900 fw-semibold mb-0 fs-18">{{ job.name }}</h1>
                            </div>
                            <div class="text-gray-900 fs-14 job-description" v-html="job.description"></div>
                            <div class="d-flex align-items-center flex-wrap toolbar-list">
                                <div class="dropdown ml-2 dropdown-wrapper-js my-1" data-bs-toggle="tooltip"
                                    data-bs-placement="top" data-bs-title="Status">
                                    <button
                                        class="btn fw-normal text-gray-700 fs-12 px-2 py-1 border-gray-100 d-flex align-items-center gap-1 shadow-none lh-1 bg-gray-100 dropdown-toggle-js rounded"
                                        @click.stop="toggleOrCloseDropdown('status')">
                                        <img :src="getJobStatusIconForJob(job.status)" class="flex-shrink-0" width="14"
                                            alt="status-icon">
                                        {{ getJobStatusLabelForJob(job.status) }}
                                    </button>
                                    <div class="dropdown-menu fh rounded-2 mt-1 py-0 border-gray-100 shadow-sm overflow-hidden dropdown-js"
                                        :class="{ 'show': statusOptions }">
                                        <ul class="list-unstyled mb-0 fs-14 list-group list-group-flush">
                                            <li class="list-group-item p-0 bg-white" v-for="status in jobStatuses"
                                                :key="status.id">
                                                <span
                                                    class="dropdown-item text-gray-700 d-flex align-items-center gap-12 py-2 px-3"
                                                    @click.prevent="updateJobStatus(status.id)">
                                                    <img :src="getJobStatusIcon(status.statusCategoryID)" width="20"
                                                        class="flex-shrink-0 d-block" alt="status-icon">
                                                    {{ status.name }}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                                <div class="dropdown ml-2 dropdown-wrapper-js my-1" data-bs-toggle="tooltip"
                                    data-bs-placement="top" data-bs-title="Priority">
                                    <button
                                        class="btn btn-light fs-12 px-1 py-1  border-gray-100 d-flex align-items-center gap-1 shadow-none dropdown-toggle-js rounded"
                                        @click.stop="toggleOrCloseDropdown('priority')">
                                        <img :src="(JOB_PRIORITY_META[job && job.priority ? job.priority : 0] && JOB_PRIORITY_META[job && job.priority ? job.priority : 0].icon) || '/img/block.svg'"
                                            class="flex-shrink-0" width="14" alt="priority-icon">
                                    </button>
                                    <div class="dropdown-menu rounded-3 mt-1 py-0 border-gray-100 shadow-sm overflow-hidden dropdown-js"
                                        :class="{ 'show': priorityOptions }">
                                        <ul class="list-unstyled mb-0 fs-12 list-group list-group-flush">
                                            <li class="list-group-item p-0 bg-white rounded-0"
                                                v-for="(meta, priority) in JOB_PRIORITY_META" :key="priority">
                                                <span
                                                    class="dropdown-item text-gray-700 d-flex align-items-center gap-12 py-2 px-3"
                                                    @click.prevent="updateJobPriority(Number(priority))">
                                                    <img :src="meta.icon" width="20"
                                                        class="flex-shrink-0 d-block rounded-0" alt="priority-icon">
                                                    {{ meta.label }}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <!-- Start Date -->
                                <DatePickerButton class="ml-2"
                                    :value="job && job.startDate && job.startDate !== MIN_DATE ? job.startDate : null"
                                    :is-open="startDatePickerOpen" icon="/img/calendar-time.svg" tooltip="Start Date"
                                    :date-type=JOB_DATE_TYPE.START
                                    :other-date-value="job && job.endDate && job.endDate !== MIN_DATE ? job.endDate : null"
                                    :other-date-type=JOB_DATE_TYPE.END
                                    @input="handleStartDateSelect($event)" @open="handleDatePickerOpen(JOB_DATE_TYPE.START)"
                                    @close="handleDatePickerClose(JOB_DATE_TYPE.START)" />
                                <!-- End Date -->
                                <DatePickerButton class="ml-2"
                                    :value="job && job.endDate && job.endDate !== MIN_DATE ? job.endDate : null"
                                    :is-open="endDatePickerOpen" icon="/img/calendar-check.svg" tooltip="End Date"
                                    :date-type=JOB_DATE_TYPE.END
                                    :other-date-value="job && job.startDate && job.startDate !== MIN_DATE ? job.startDate : null"
                                    :other-date-type=JOB_DATE_TYPE.START
                                    @input="handleEndDateSelect($event)" @open="handleDatePickerOpen(JOB_DATE_TYPE.END)"
                                    @close="handleDatePickerClose(JOB_DATE_TYPE.END)" />

                                <div class="dropdown ml-2 dropdown-wrapper-js" data-bs-toggle="tooltip"
                                    data-bs-placement="top" data-bs-title="Assignee">
                                    <button
                                        class="btn fs-12 px-1 py-1 d-flex align-items-center gap-1 shadow-none dropdown-toggle-js rounded"
                                        :class="jobAssigneeIds.length ? 'border-none bg-transparent' : 'border-gray-100'"
                                        @click.stop="toggleOrCloseDropdown('assignee')">
                                        <JobAssigneeAvatars :assignees="jobAssigneeIds" :users="accountUsers" />
                                    </button>
                                    <div class="dropdown-menu fh rounded-3 mt-1 py-0 border-gray-100 shadow-sm overflow-hidden dropdown-js"
                                        :class="{ 'show': assigneeOptions }">
                                        <ul class="list-unstyled mb-0 fs-14 list-group list-group-flush w-224">
                                            <li v-for="user in accountUsers" :key="user.id"
                                                class="list-group-item p-0 bg-white d-flex rounded-0">
                                                <span
                                                    class="dropdown-item text-gray-700 d-flex align-items-center gap-12 py-2 px-3 w-100"
                                                    :class="{ 'fw-semibold text-gray-900': jobAssigneeIds.includes(user.id) }"
                                                    @click.prevent="toggleJobAssignee(user.id)">
                                                    <img :src="user.profileImageUrl || '/img/avatar.svg'" width="20"
                                                        height="20" class="rounded-circle flex-shrink-0"
                                                        alt="profile-image-icon">
                                                    <span class="assignee-name text-truncate ml-0">{{ user.name
                                                        }}</span>
                                                    <img v-if="jobAssigneeIds.includes(user.id)" src="/img/check.svg"
                                                        width="16" class="mx-0 d-block" alt="assignee-icon">
                                                </span>
                                            </li>
                                            <li v-if="accountUsers.length === 0" class="list-group-item p-0 bg-white">
                                                <span
                                                    class="dropdown-item text-gray-700 d-flex align-items-center gap-12 py-2 px-3">No
                                                    users</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                                <div class="dropdown ml-2 dropdown-wrapper-js" data-bs-toggle="tooltip"
                                    data-bs-placement="top" data-bs-title="Tags">
                                    <button
                                        class="btn btn-light fs-12 px-1 py-1  border-gray-100 d-flex align-items-center gap-1 shadow-none dropdown-toggle-js rounded"
                                        @click.stop="toggleOrCloseDropdown('tag')">
                                        <img src="/img/tags.svg" class="flex-shrink-0" width="14" alt="tags-icon">
                                        <p v-if="getJobTagDisplayText(job)" class="mt-0 mb-0 fs-12 fw-normal">{{ getJobTagDisplayText(job) }}</p>
                                    </button>
                                    <div class="dropdown-menu rounded-3 mt-1 py-0 border-gray-100 shadow-sm overflow-hidden w-280 dropdown-js"
                                        :class="{ 'show': tagOptions }" @click.stop>
                                        <div
                                            class="p-2 border-bottom border-gray-100 d-flex gap-2 align-items-center rounded-0">
                                            <div class="position-relative flex-fill">
                                                <img src="/img/search.svg"
                                                    class="search position-absolute start-0 top-50 translate-middle-y ml-2"
                                                    width="20" alt="search-icon">
                                                <input type="text"
                                                    class="search-input form-control ps-40 border-gray-300 text-gray-500 fs-14 fw-normal"
                                                    placeholder="Search" :value="tagSearchQuery"
                                                    @input="handleTagSearch"
                                                    @keydown="handleTagKeydown">
                                            </div>
                                            <button v-b-modal.ManageTags
                                                class="add-btn btn border border-gray-200 p-0 rounded-circle box-32 d-flex align-items-center justify-content-center border-dashed">
                                                <img src="/img/plus-light.svg" class="d-block" width="16"
                                                    alt="open-managetags-modal-icon">
                                            </button>
                                        </div>
                                        <div class="tags-scrollable-container w-280">
                                            <ul class="list-unstyled mb-0 fs-14 list-group list-group-flush">
                                                <li v-for="tag in getFilteredTagsForJob()" :key="tag.id"
                                                    class="list-group-item p-0 bg-white d-flex rounded-0">
                                                    <span
                                                        class="dropdown-item text-gray-700 d-flex align-items-center gap-12 py-2 px-3"
                                                        @click.prevent="toggleJobTagSelection(tag)"
                                                        :class="{ 'fw-semibold text-gray-900': isJobTagSelected(tag) }">
                                                        <div class="dot"></div>
                                                        {{ tag.name }}
                                                        <img v-if="isJobTagSelected(tag)" src="/img/check.svg"
                                                            width="16" class="ml-auto mx-3 d-block"
                                                            alt="tags-check-icon">
                                                    </span>
                                                </li>
                                                <li v-if="getFilteredTagsForJob().length === 0"
                                                    class="list-group-item p-0 bg-white">
                                                    <span
                                                        class="text-gray-700 d-flex align-items-center gap-12 py-2 px-3">
                                                        <div class="dot"></div>
                                                        {{ tagSearchQuery ? 'No tags found' : 'No tags available' }}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="d-flex justify-content-start" v-if="activities && activities.length > 0">
                                <div class="d-flex align-items-center gap-1 fs-12">
                                    <img src="/img/last-updated-timer.svg" alt="last-updated-activity-timer-icon" />
                                    <span class="text-gray-400">Last edited by {{ getUserName(activities[0].userId) }}
                                        on {{ formatLocalDate((activities[0].createdAt).slice(0, 10)) }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-center gap-1 flex-wrap mb-3">
                        </div>
                        <associatedProofs :job-id="jobId" />
                        <JobFiles :job-id="jobId" />
                        <AssociatedContacts
                            :job-id="jobId"
                            :contacts="contacts"
                            @contacts-changed="reloadContacts" />
                        <JobActivities ref="jobActivities" :activities="orderedActivities" :comments="comments"
                            :account-users="accountUsers" :job-tags="jobTags" :current-user="currentUser"
                            :job-statuses="jobStatuses" @add-reaction="handleAddReaction"
                            @remove-reaction="handleRemoveReaction" @save-comment="handleSaveComment"
                            @delete-comment="handleDeleteComment" @job-updated="handleJobUpdated" />
                        <div class="comments-section border-top p-4">
                            <label class="fs-14 fw-normal text-gray-700 mb-1 d-block text-gray-700">Comment</label>
                            <redactor 
                                ref="commentRedactor"
                                :placeholder="'Add a comment...'"
                                :comment-api-url="commentFileApi"
                                :cur-users-taggable="curUsersTaggable"
                                :show-preview="false"
                                :show-source="true"
                                :use-payload-auth="true"
                                @input="updateCommentText"
                                class="mb-2" />
                            <div class="comment-btn">
                                <button class="btn bg-success-500 fs-12 py-2 px-12 fw-normal fs-12 rounded" :disabled="!hasMeaningfulContent()"
                                    @click="submitComment">New
                                    Comment</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <modalManageTags tag-type="job" />
        <modalAddJob ref="manageJobModal" :default-job-status="job && job.status" :account-users-prop="accountUsers"
            :job-tags-prop="jobTags" :job-statuses-prop="jobStatuses" @job-edited="handleJobEdited" />
        <modalDeleteJob ref="deleteJobModal" @confirmed="confirmDeleteJob" />
    </div>
</template>

<script>
import DatePickerButton from "../components/job-item/datePickerButton.vue";
import navigation from "../components/global/navigation.vue";
import modalManageTags from "../components/modals/modal-managetags.vue";
import modalAddJob from "../components/modals/modal-add-job.vue";
import modalDeleteJob from "../components/modals/modal-delete-job.vue";
import JobActivities from "../components/job-item/job-activities.vue";
import JobAssigneeAvatars from "../components/job-item/job-assignee-avatars.vue";
import redactor from "../components/form/redactor.vue";
import associatedProofs from "../components/job-item/associated-proofs.vue";
import JobFiles from "../components/job-item/job-files.vue";
import AssociatedContacts from "../components/job-item/associated-contacts.vue";

import { JOB_STATUS_META, JOB_PRIORITY_META, MIN_DATE, ROUTES, VARIANT, JOB_EVENT_TYPE, EVENT_ACTION_TYPE, TYPES_ENUM, CALENDAR_TYPE, JOB_DATE_TYPE } from "../utils/constants";
import { handleDropdownPosition, formatLocalDate, formatTagDisplayText, createTaggableUsers, createTagOnEnter, addTargetBlankToLinks, getJobAssigneeIds } from '../utils/helpers';

const { JOB_LIST } = ROUTES;
const { DANGER, SUCCESS } = VARIANT;
const { Commented } = JOB_EVENT_TYPE;
const { COMMENT_EDITED, COMMENT_DELETED, REACTION_ADDED, REACTION_REMOVED } = EVENT_ACTION_TYPE;
const { NUMBER, STRING, OBJECT } = TYPES_ENUM;

export default {
    name: 'JobDetails',
    components: {
        DatePickerButton,
        navigation,
        modalManageTags,
        modalAddJob,
        modalDeleteJob,
        JobActivities,
        JobAssigneeAvatars,
        JobFiles,
        AssociatedContacts,
        redactor,
        associatedProofs
    },
    async mounted() {
        this.jobId = Number(window.location.pathname.split('/').pop());
        await this.getAllJobData();
        this.$A.JobService.markViewed(this.jobId).catch(() => {});
        await this.registerJobRealtimeConnection();
        document.addEventListener('click', this.handleOutsideClick);
        window.addEventListener('resize', handleDropdownPosition);
        this.$nextTick(() => {
            handleDropdownPosition();
        });

        // Listen for job tags reloaded event from manage tags modal
        this.$root.$on('job-tags::reloaded', () => this.getJobTags(true));
    },
    data() {
        return {
            jobId: null,
            contacts: [],
            JOB_STATUS_META,
            JOB_PRIORITY_META,
            JOB_EVENT_TYPE,
            MIN_DATE,
            JOB_DATE_TYPE,
            job: null,
            activities: [],
            isLoading: true,
            accountUsers: [],
            jobTags: [],
            jobStatuses: [],
            startDate: '',
            endDate: '',
            startDatePickerOpen: false,
            endDatePickerOpen: false,
            statusOptions: false,
            priorityOptions: false,
            assigneeOptions: false,
            tagOptions: false,
            tagSearchQuery: '',
            commentText: '',
            // realtime job hub
            realTimeJobConnection: null,
            isJobConnecting: false,
            comments: [],
            currentUser: this.$A.Auth,
            pendingTagAdds: [],
            pendingTagRemoves: [],
            // Prevent duplicate API calls
            isLoadingJobTags: false,
        };
    },
    beforeDestroy() {
        try { this.realTimeJobConnection && this.realTimeJobConnection.stop(); } catch (e) { }
        document.removeEventListener('click', this.handleOutsideClick);
        window.removeEventListener('resize', handleDropdownPosition);

        // Clean up event listener
        this.$root.$off('job-tags::reloaded');
    },
    methods: {
        createTaggableUsers,
        formatLocalDate,
        handleDropdownPosition,
        async getJobTags(forceReload = false) {
            if (this.isLoadingJobTags || (this.jobTags.length > 0 && !forceReload)) {
                return;
            }

            this.isLoadingJobTags = true;
            try {
                this.jobTags = await this.$A.JobTagService.GetAll();
            } catch {
                this.jobTags = [];
            } finally {
                this.isLoadingJobTags = false;
            }
        },
        async confirmDeleteJob(job) {
            try {
                if (!job || !job.id) return;
                await this.$A.JobService.deleteJob(job.id);
                this.$toast('Job Deleted Successfully', { title: 'Success', variant: SUCCESS });
                this.$router.push(JOB_LIST);
            } catch (e) {
                console.error('Failed to delete job', e);
                this.$toast('Failed to delete job', { title: 'Error', variant: DANGER });
            }
        },
        async handleJobEdited({ jobId, jobData }) {
            try {
                const contactsToAdd = Array.isArray(jobData._contactsToAdd) ? jobData._contactsToAdd : [];
                const contactsToRemove = Array.isArray(jobData._contactsToRemove) ? jobData._contactsToRemove : [];
                const { _contactsToAdd, _contactsToRemove, ...persistableJobData } = jobData;

                await this.$A.JobService.updateJobById({ jobId, jobData: persistableJobData });

                if (contactsToAdd.length || contactsToRemove.length) {
                    try {
                        await this.$A.JobService.updateContactLink({
                            jobId,
                            update: contactsToAdd,
                            delete: contactsToRemove,
                        });
                    } catch (e) {
                        console.error("Failed to update job contacts:", e);
                    }
                }

                // If tags or contacts were updated, refresh the entire job data
                const tagsChanged = persistableJobData.tags && (persistableJobData.tags.update || persistableJobData.tags.delete);
                const contactsChanged = contactsToAdd.length || contactsToRemove.length;
                if (tagsChanged || contactsChanged) {
                    const jobResponse = await this.$A.JobService.getJobById(jobId);
                    this.job = jobResponse.job;
                    this.activities = jobResponse.activities || this.activities;
                    this.contacts = jobResponse.contacts || this.contacts;
                } else {
                    this.job = { ...this.job, ...persistableJobData };
                    try { this.activities = (await this.$A.JobService.getJobById(jobId)).activities || this.activities; } catch { }
                }
            } catch (e) {
                console.error('Failed to update job', e);
                this.$toast('Failed to update job', { title: 'Error', variant: DANGER });
            }
        },
        async handleJobUpdated() {
            try {
                // Refresh the job data to get updated tags and other changes
                const jobResponse = await this.$A.JobService.getJobById(this.jobId);
                this.job = jobResponse.job;
                this.activities = jobResponse.activities || this.activities;
            } catch (e) {
                console.error('Failed to refresh job data:', e);
            }
        },
        handleCommentEdit(payload) {
            if (payload.jobId && Number(payload.jobId) !== Number(this.jobId)) {
                return;
            }
            this.$refs.jobActivities?.handleCommentEdit?.(payload);
        },
        handleCommentDelete(payload) {
            if (payload.jobId && Number(payload.jobId) !== Number(this.jobId)) {
                return;
            }
            this.$refs.jobActivities?.handleCommentDelete?.(payload);
        },
        getUserName(userId) {
            const user = this.accountUsers.find(u => u.id === userId);
            return user ? user.name : 'Unknown User';
        },
        async registerJobRealtimeConnection() {
            try {
                // Ensure we have a job to subscribe to
                if (!this.job || !this.job.id) return;

                if (this.realTimeJobConnection) return;
                // Connect to job_hub using the shared realtime service
                this.realTimeJobConnection = this.$A.RealtimeService.Connect('job_hub');

                // ReadyForRegistration: send token + jobId (mirrors review hub pattern)
                this.realTimeJobConnection.on('ReadyForRegistration', async () => {
                    try {
                        const token = _.get(this, '$A.Auth.apiToken.token', '');
                        if (token) {
                            // If backend expects a different method name, adjust here
                            await this.realTimeJobConnection.invoke('RegisterJobConnection', token, this.job.id);
                        }
                    } catch (e) {
                        console.error('Job hub registration error:', e);
                    }
                });

                // Registered: connected and ready
                this.realTimeJobConnection.on('Registered', async () => {
                });

                // Handle job update events (use common event names defensively)
                const applyJobUpdate = (payload) => {
                    if (!payload || !payload.jobId || Number(payload.jobId) !== Number(this.jobId)) return;

                    try {
                        // Handle special comment edit/delete payloads
                        if (payload.action === COMMENT_EDITED && payload.commentId) {
                            this.handleCommentEdit(payload);
                            return;
                        }

                        if (payload.action === COMMENT_DELETED && payload.commentId) {
                            this.handleCommentDelete(payload);
                            return;
                        }

                        // Handle comment reaction add/remove in realtime
                        if ((payload.action === REACTION_ADDED || payload.action === REACTION_REMOVED) && payload.commentId) {
                            if (payload.action === REACTION_ADDED) {
                                this.handleReactionAdded(payload);
                            } else {
                                this.handleReactionRemoved(payload);
                            }
                            return;
                        }

                        this.handleJobPropertyUpdate(payload);

                        const userName = this.getUserName(payload.userId) || null;

                        // Skip adding if userName cannot be resolved
                        if (!userName) {
                            console.warn('Unknown user, skipping activity:', payload);
                            return;
                        }

                        const commentEventPayload = {
                            comment: payload.eventValueData,
                            commentedBy: payload.id,
                            jobId: payload.jobId,
                            createdAt: payload.createdAt,
                            reactions: [],
                            id: Number(payload.eventValue)
                        }

                        const activityPayload = {
                            id: payload.id,
                            userId: payload.userId,
                            eventTypeId: payload.eventTypeId,
                            eventType: payload.eventType,
                            description: payload.description,
                            eventValue: payload.eventValue,
                            createdAt: payload.createdAt,
                            userName: this.getUserName(payload.userId),
                            ...(payload.eventTypeId === Commented && { comment: commentEventPayload }),
                        };

                        const commentPayload = {
                            eventDescription: payload.description,
                            eventValue: payload.eventValueData,
                            eventTypeName: payload.eventType,
                            reactions: [],
                            id: Number(payload.eventValue),
                            comment: payload.eventValueData,
                            commentedBy: payload.userId,
                            createdAt: payload.createdAt,
                        };

                        this.activities = [activityPayload, ...this.activities];
                        this.comments = [commentPayload, ...this.comments];
                    } catch (e) {
                        console.error('Failed applying job update payload:', e);
                    }
                };

                this.realTimeJobConnection.on('ReceiveJobEvents', applyJobUpdate);
                await this.startJobConnection();
            } catch (e) {
                console.error('Failed to register job realtime connection:', e);
            }
        },
        async startJobConnection() {
            if (this.isJobConnecting || !this.realTimeJobConnection) return;
            try {
                this.isJobConnecting = true;
                await this.realTimeJobConnection.start();
                this.isJobConnecting = false;
            } catch (err) {
                console.error('Error connecting to job hub:', err);
                setTimeout(this.startJobConnection, 5000);
            }
        },
        async reloadContacts() {
            try {
                const jobResponse = await this.$A.JobService.getJobById(this.jobId);
                this.contacts = jobResponse.contacts || [];
                this.activities = jobResponse.activities || this.activities;
            } catch (e) {
                console.error("Failed to reload contacts:", e);
            }
        },
        async getAllJobData() {
            try {
                const jobResponse = await this.$A.JobService.getJobById(this.jobId);
                this.job = jobResponse.job;
                this.activities = jobResponse.activities || [];
                this.comments = jobResponse.comments || [];
                this.contacts = jobResponse.contacts || [];
                try { this.accountUsers = await this.$A.AccountService.All(); } catch { this.accountUsers = []; }
                await this.getJobTags();
                try { this.jobStatuses = await this.$A.JobStatusService.getAllJobStatuses(); } catch { this.jobStatuses = []; }
                // If connection already created before job loaded, ensure registration happens after data fetch
                if (this.realTimeJobConnection) {
                    try {
                        const token = _.get(this, '$A.Auth.apiToken.token', '');
                        if (token && this.job?.id) {
                            await this.realTimeJobConnection.invoke('RegisterJobConnection', token, this.job.id);
                        }
                    } catch (e) {
                        console.error('Deferred job hub registration failed:', e);
                    }
                }
            } catch (e) {
                console.error('Failed to init job details', e);
            } finally {
                this.isLoading = false;
            }
        },
        handleTagSearch(e) {
            this.tagSearchQuery = (e && e.target ? e.target.value : e) || '';
        },
        handleTagKeydown(event) {
            createTagOnEnter(
                event, 
                this.tagSearchQuery, 
                this.jobTags, 
                this.$A.JobTagService,
                () => this.tagSearchQuery = '',
                (message) => this.$toast(message, { title: 'Error', variant: 'danger' })
            );
        },
        getFilteredTagsForJob() {
            const query = (this.tagSearchQuery || '').toLowerCase().trim();
            if (!query) return this.jobTags;
            return this.jobTags.filter(tag => (tag.name || '').toLowerCase().includes(query));
        },
        getJobTagIdSet() {
            const candidate = this.job?.tags || this.job?.jobTags || this.job?.tagIds || this.job?.taggedItems || this.job?.tagLinks || [];
            const idByName = {};
            (this.jobTags || []).forEach(t => { idByName[t.name] = t.id; });
            if (!Array.isArray(candidate) || candidate.length === 0) return new Set();
            const first = candidate[0];
            if (typeof first === NUMBER) return new Set(candidate);
            if (typeof first === STRING) return new Set(candidate.map(n => idByName[n]).filter(Boolean));
            if (first && typeof first === OBJECT) {
                if ('tagId' in first) return new Set(candidate.map(l => l.tagId).filter(Boolean));
                if ('id' in first) return new Set(candidate.map(t => t.id).filter(Boolean));
            }
            return new Set();
        },
        isJobTagSelected(tag) {
            const baseIds = this.getJobTagIdSet();
            const base = baseIds.has(tag.id);
            const added = (this.pendingTagAdds || []).includes(tag.id);
            const removed = (this.pendingTagRemoves || []).includes(tag.id);
            return (base || added) && !removed;
        },
        getJobTagDisplayNames(job) {
            if (!job) return [];

            const candidate = job.tags || job.jobTags || job.tagIds || job.taggedItems || job.tagLinks || [];
            if (!Array.isArray(candidate) || candidate.length === 0) return [];

            const first = candidate[0];

            if (typeof first === STRING) return candidate.filter(Boolean);
            if (typeof first === NUMBER) {
                const idToName = {};
                (this.jobTags || []).forEach(t => {
                    idToName[t.id] = t.name;
                });
                return candidate.map(id => idToName[id]).filter(Boolean);
            }
            if (first && typeof first === OBJECT) {
                if ('name' in first) {
                    return candidate.map(t => t && t.name).filter(Boolean);
                }
                if ('tagId' in first) {
                    const idToName = {};
                    (this.jobTags || []).forEach(t => {
                        idToName[t.id] = t.name;
                    });
                    return candidate.map(link => idToName[link.tagId]).filter(Boolean);
                }
                if ('id' in first && !('name' in first)) {
                    const idToName = {};
                    (this.jobTags || []).forEach(t => {
                        idToName[t.id] = t.name;
                    });
                    return candidate.map(t => idToName[t.id]).filter(Boolean);
                }
            }
            
            return [];
        },
        async toggleJobTagSelection(tag) {
            if (!this.job) return;
            const baseSelected = this.getJobTagIdSet().has(tag.id);
            const effectiveSelected = this.isJobTagSelected(tag);

            if (effectiveSelected) {
                this.pendingTagAdds = (this.pendingTagAdds || []).filter(id => id !== tag.id);
                if (baseSelected && !(this.pendingTagRemoves || []).includes(tag.id)) this.pendingTagRemoves.push(tag.id);
            } else {
                this.pendingTagRemoves = (this.pendingTagRemoves || []).filter(id => id !== tag.id);
                if (!baseSelected && !(this.pendingTagAdds || []).includes(tag.id)) this.pendingTagAdds.push(tag.id);
            }
        },

        async refreshJobData() {
            try {
                const jobResponse = await this.$A.JobService.getJobById(this.job.id);
                this.comments = jobResponse.comments || [];
            } catch (error) {
                console.error('Failed to refresh job data:', error);
            }
        },

        async handleAddReaction(reactionRequest) {
            try {
                await this.$A.JobCommentReactionService.addReaction(reactionRequest, true);
                await this.refreshJobData();
            } catch (error) {
                console.error('Failed to add reaction:', error);
                this.$toast('Failed to add reaction', { title: 'Error', variant: DANGER });
            }
        },

        // Realtime reaction handlers
        handleReactionAdded(payload) {
            if (payload.jobId && Number(payload.jobId) !== Number(this.jobId)) {
                return;
            }
            this.$refs.jobActivities?.handleReactionAdded?.(payload);
        },
        handleReactionRemoved(payload) {
            if (payload.jobId && Number(payload.jobId) !== Number(this.jobId)) {
                return;
            }
            this.$refs.jobActivities?.handleReactionRemoved?.(payload);
        },
        async handleRemoveReaction(reactionId) {
            if (!reactionId) return;
            try {
                await this.$A.JobCommentReactionService.removeReaction(reactionId, true);
                await this.refreshJobData();
            } catch (error) {
                this.$toast('Failed to remove reaction', { title: 'Error', variant: DANGER });
            }
        },
        async handleSaveComment({ commentId, comment }) {
            try {
                await this.$A.JobCommentService.updateComment({ commentId, comment });
                await this.refreshJobData();
            } catch (e) {
                this.$toast('Failed to update comment', { title: 'Error', variant: DANGER });
            }
        },
        async handleDeleteComment(commentId) {
            try {
                await this.$A.JobCommentService.deleteComment(commentId);
                await this.refreshJobData();
            } catch (e) {
                this.$toast('Failed to delete comment', { title: 'Error', variant: DANGER });
            }
        },
        handleOutsideClick(event) {
            const clickedEl = event.target;
            if (clickedEl.closest('.mx-calendar-header') || clickedEl.closest('.mx-calendar-panel-year') || clickedEl.closest('.mx-calendar-panel-month')) {
                return;
            }
            this.updateToggle();
            this.closeAllDatePickers();
        },

        updateToggle() {
            this.closeAllDropdowns();
        },

        closeDropdown(type) {
            this[`${type}Options`] = false;
            this.closeAllDatePickers();
        },

        closeAllDatePickers() {
            this.startDatePickerOpen = false;
            this.endDatePickerOpen = false;
        },

        closeAllDropdowns() {
            // Save pending tag changes before closing all dropdowns
            if (this.tagOptions) {
                this.commitPendingJobTags();
            }
            
            this.statusOptions = false;
            this.priorityOptions = false;
            this.assigneeOptions = false;
            this.tagOptions = false;
            this.closeAllDatePickers();
        },

        handleDatePickerOpen(type) {
            this.closeAllDatePickers();
            this.closeAllDropdowns();
            if (type === JOB_DATE_TYPE.START) {
                this.startDatePickerOpen = true;
            } else if (type === JOB_DATE_TYPE.END) {
                this.endDatePickerOpen = true;
            }
        },

        handleDatePickerClose(type) {
            if (type === JOB_DATE_TYPE.START) {
                this.startDatePickerOpen = false;
            } else if (type === JOB_DATE_TYPE.END) {
                this.endDatePickerOpen = false;
            }
        },

        toggleOrCloseDropdown(type) {
            const key = `${type}Options`;
            // If open, close it
            if (this[key]) {
                if (type === 'tag') {
                    this.commitPendingJobTags();
                }
                this[key] = false;
            } else {
                this.updateToggle(); // Close others
                this[key] = true;
                if (type === 'tag') {
                    this.pendingTagAdds = [];
                    this.pendingTagRemoves = [];
                }
            }
            this.closeAllDatePickers();
        },

        async commitPendingJobTags() {
            try {
                const toUpdate = (this.pendingTagAdds || []).slice();
                const toDelete = (this.pendingTagRemoves || []).slice();
                if ((!toUpdate || toUpdate.length === 0) && (!toDelete || toDelete.length === 0)) return;

                const updateJobRequest = {
                    jobId: this.job.id,
                    jobData: {
                        tags: {
                            update: toUpdate,
                            delete: toDelete
                        }
                    }
                };

                await this.$A.JobService.updateJobById(updateJobRequest);
                
                // Refresh the job data to get updated tags
                const jobResponse = await this.$A.JobService.getJobById(this.job.id);
                this.job = jobResponse.job;
                this.activities = jobResponse.activities || this.activities;
            } catch (e) {
                console.error('Failed to update tags for job:', e);
                this.$toast('Failed to update tags', { title: 'Error', variant: DANGER });
            } finally {
                this.pendingTagAdds = [];
                this.pendingTagRemoves = [];
            }
        },

        clearStartDate() {
            if (!this.job) return;
            try {
                this.$A.JobService.updateJobById({ jobId: this.job.id, jobData: { startDate: MIN_DATE } });
                this.job.startDate = null;
            } catch (e) {
                this.$toast('Failed to clear start date', { title: 'Error', variant: DANGER });
            }
        },

        clearEndDate() {
            if (!this.job) return;
            try {
                this.$A.JobService.updateJobById({ jobId: this.job.id, jobData: { endDate: MIN_DATE } });
                this.job.endDate = null;
            } catch (e) {
                this.$toast('Failed to clear end date', { title: 'Error', variant: DANGER });
            }
        },
        // Status/Priority updates
        async updateJobStatus(newStatus) {
            if (!this.job) return;
            try {
                await this.$A.JobService.updateJobById({ jobId: this.job.id, jobData: { status: newStatus } });
                this.job.status = newStatus;
                this.statusOptions = false;
            } catch (e) {
                this.$toast('Failed to update status', { title: 'Error', variant: DANGER });
            }
        },
        async updateJobPriority(newPriority) {
            if (!this.job) return;
            try {
                await this.$A.JobService.updateJobById({ jobId: this.job.id, jobData: { priority: newPriority } });
                this.job.priority = newPriority;
                this.priorityOptions = false;
            } catch (e) {
                this.$toast('Failed to update priority', { title: 'Error', variant: DANGER });
            }
        },
        async toggleJobAssignee(userId) {
            if (!this.job) return;
            const previous = this.jobAssigneeIds;
            const assignees = previous.includes(userId)
                ? previous.filter(id => id !== userId)
                : [...previous, userId];
            this.$set(this.job, 'assignees', assignees);
            try {
                await this.$A.JobService.updateJobById({ jobId: this.job.id, jobData: { assignees } });
            } catch (e) {
                this.$set(this.job, 'assignees', previous);
                this.$toast('Failed to update assignee', { title: 'Error', variant: DANGER });
            }
        },
        // Dates
        asDateForPicker(value) {
            if (!value) return null;
            if (value instanceof Date) return value;
            if (typeof value === STRING && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
                // Plain date -> construct Date in UTC midnight, then return Date
                return new Date(value + 'T00:00:00Z');
            }
            if (typeof value === STRING && !value.endsWith('Z') && value.includes('T')) {
                // Timestamp without Z
                return new Date(value + 'Z');
            }
            return new Date(value);
        },
        async handleStartDateSelect(value) {
            if (!this.job) return;
            try {
                await this.$A.JobService.updateJobById({ jobId: this.job.id, jobData: { startDate: value } });
                this.job.startDate = value;
            } catch (e) {
                this.$toast('Failed to update start date', { title: 'Error', variant: DANGER });
            }
        },
        async handleEndDateSelect(value) {
            if (!this.job) return;
            try {
                await this.$A.JobService.updateJobById({ jobId: this.job.id, jobData: { endDate: value } });
                this.job.endDate = value;
            } catch (e) {
                this.$toast('Failed to update end date', { title: 'Error', variant: DANGER });
            }
        },
        updateCommentText(htmlContent) {
            this.commentText = htmlContent;
        },
        hasMeaningfulContent() {
            if (!this.commentText) return false;
            const textContent = this.commentText.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
            const figureContent = this.commentText.includes('<figure');
            return textContent.length > 0 || figureContent;
        },
        async submitComment() {
            if (!this.job || !this.hasMeaningfulContent()) return;
            try {
                const processedComment = addTargetBlankToLinks(this.$refs.commentRedactor?.getTextBody?.() || this.commentText.trim());
                const request = { jobId: this.job.id, comment: processedComment };
                await this.$A.JobCommentService.addComment(request);
                this.commentText = '';
                // Clear the redactor content
                this.$refs.commentRedactor?.setTextBody?.('');
                // Refresh comments to show the new comment
                await this.refreshJobData();
            } catch (e) {
                console.error('Failed to add comment', e);
                this.$toast('Failed to add comment', { title: 'Error', variant: DANGER });
            }
        },
        getPriorityIcon(priorityId) {
            return JOB_PRIORITY_META[priorityId]?.icon;
        },
        getPriorityLabel(priorityId) {
            return JOB_PRIORITY_META[priorityId]?.label;
        },
        // Status helpers
        getJobStatusIcon(statusCategoryID) {
            const meta = JOB_STATUS_META[statusCategoryID];
            return meta ? meta.icon : '/img/block.svg';
        },
        getJobStatusIconForJob(statusId) {
            const s = this.jobStatuses.find(x => x.id === statusId);
            return this.getJobStatusIcon(s?.statusCategoryID);
        },
        getJobStatusLabelForJob(statusId) {
            const s = this.jobStatuses.find(x => x.id === statusId);
            return s ? s.name : 'Unknown Status';
        },
        getJobTagDisplayText(job) {
            return formatTagDisplayText(this.getJobTagDisplayNames(job));
        },
        updateJobTagsFromRealtimeEvent(tagChanges) {
            if (!this.job || !tagChanges) return;
            
            try {
                const {removed, added } = tagChanges;
                if (removed.length) {
                    this.job.jobTags = this.job.jobTags.filter(
                        tag => !removed.some(r => r.Id === tag.id)
                    );
                }
                if (added.length) {
                    const formatted = added.map(a => ({
                        id: a.Id,
                        name: a.Name,
                        accountId: this.job.accountId,
                    }));
                    this.job.jobTags.push(...formatted);
                }
            } catch (e) {
                console.error('Failed to update job tags from realtime event:', e);
            }
        },
        parseAssigneeEventValue(eventValue) {
            if (!eventValue) return null;
            try {
                if (typeof eventValue === STRING && eventValue.startsWith('{')) {
                    const parsed = JSON.parse(eventValue);
                    return Number(parsed.UserId || parsed.userId) || null;
                }
                return Number(eventValue) || null;
            } catch (e) {
                console.error('Failed to parse assignee eventValue:', eventValue, e);
                return null;
            }
        },
        handleJobPropertyUpdate(payload) {
            if (!this.job || !payload.eventTypeId) return;

            try {
                switch (payload.eventTypeId) {
                    case JOB_EVENT_TYPE.StatusChanged:
                        if (payload.eventValue) {
                            const statusData = typeof payload.eventValue === STRING
                                ? JSON.parse(payload.eventValue)
                                : payload.eventValue;
                            if (statusData.statusId) {
                                this.job.status = statusData.statusId;
                            }
                        }
                        break;
                    case JOB_EVENT_TYPE.Assigned: {
                        const userId = this.parseAssigneeEventValue(payload.eventValue);
                        if (userId && !this.jobAssigneeIds.includes(userId)) {
                            this.$set(this.job, 'assignees', [...this.jobAssigneeIds, userId]);
                        }
                        break;
                    }
                    case JOB_EVENT_TYPE.StartDateChanged:
                        if (payload.eventValue) {
                            this.job.startDate = payload.eventValue;
                        }
                        break;
                    case JOB_EVENT_TYPE.StartDateRemoved:
                        this.job.startDate = null;
                        break;
                    case JOB_EVENT_TYPE.EndDateChanged:
                        if (payload.eventValue) {
                            this.job.endDate = payload.eventValue;
                        }
                        break;
                    case JOB_EVENT_TYPE.EndDateRemoved:
                        this.job.endDate = null;
                        break;
                    case JOB_EVENT_TYPE.PriorityChanged:
                        if (payload.eventValue) {
                            this.job.priority = Number(payload.eventValue);
                        }
                        break;
                    case JOB_EVENT_TYPE.Unassigned: {
                        const userId = this.parseAssigneeEventValue(payload.eventValue);
                        // Legacy events carry no user id: treat as "unassign all".
                        this.$set(this.job, 'assignees', userId ? this.jobAssigneeIds.filter(id => id !== userId) : []);
                        break;
                    }
                    case JOB_EVENT_TYPE.TagsUpdated:
                        if (payload.eventValue) {
                            try {
                                const tagChanges = typeof payload.eventValue === STRING 
                                    ? JSON.parse(payload.eventValue) 
                                    : payload.eventValue;
                                
                                this.updateJobTagsFromRealtimeEvent(tagChanges);
                            } catch (e) {
                                console.error('Failed to parse tag changes:', payload.eventValue, e);
                            }
                        }
                        this.getJobTags();
                        break;
                    default:
                        break;
                }
            } catch (e) {
                console.error('Failed to update job property from realtime event:', e);
            }
        },
    },
    computed: {
        jobAssigneeIds() {
            return getJobAssigneeIds(this.job);
        },
        orderedActivities() {
            if (!this.activities || this.activities.length === 0) {
                return [];
            }
            return [...this.activities].sort((a, b) => {
                const timeA = new Date(a.createdAt).getTime();
                const timeB = new Date(b.createdAt).getTime();
                return timeA - timeB;
            });
        },
        curUsersTaggable: function () {
            return createTaggableUsers(this.currentUser, this.accountUsers);
        },
        commentFileApi: function () {
            const authToken = this.$A.Auth.apiToken.token;
            if (this.$A.Auth) {
                let apiUrl= `/jobs/${this.job.id}/files?access_token=${authToken}`;
                return apiUrl;
            }
            return "";
        },
    }
};
</script>

<style scoped>
::v-deep .comments-section .progress {
    display: none !important;
}

.add-btn {
    border-width: 2px !important;
    border-radius: 16px !important;
}

::v-deep [data-command="loom.toggle"] {
  display: none !important;
}

.btn {
    line-height: 12px;
}

.assignee-name {
    width: 140px;
}

.w-224 {
    width: 224px !important;
}

.w-280 {
    width: 280px !important;
}

.dropdown-menu.fh {
    max-height: 200px !important;
    overflow-y: auto !important;
}

.tags-scrollable-container {
    max-height: 165px !important;
    overflow-y: auto;
    border-radius: 0px !important;
}

.back-btn a {
    color: #909092;
}

.job-details-section {
    background-color: #FFFFFF;
    min-height: 90vh;
    overflow-x: hidden !important;
}

.job-header {
    margin-bottom: 32px;
}

.emoji-picker-comment {
    z-index: 1000;
    top: 100%;
    left: 0;
    margin-top: 5px;
}

.selected-emoji {
    cursor: pointer;
    padding: 4px 8px;
    background-color: rgb(63, 118, 255, 0.1);
    border-radius: 6px;
    margin-right: 8px;
}

.selected-emoji.me {
    background-color: lightblue;
}

.user-profile-image {
    border-radius: 50%;
    height: 28px;
    width: 28px;
    background-size: cover;
    vertical-align: middle;
    background-color: #444444;
    display: inline-block;
}

.w-224 {
    min-width: 224px !important;
}

.w-280 {
    min-width: 280px !important;
}

.job-details-section {
    background-color: #FFFFFF;
}

.search.top-50 {
    top: 50% !important;
}

.search-input {
    padding: 2px 2px 2px 32px;
}

.rounded-0 {
    border-radius: 0px !important;
}

.w-300 {
    width: 300px !important;
}

.tag-added {
    background-color: rgba(22, 163, 74, 0.08) !important;
}

.tag-removed {
    background-color: rgba(220, 38, 38, 0.08) !important;
}

.comment-btn {
    display: flex;
    justify-content: end;
}

.comment-btn .btn {
    color: #F9F9F9;
    height: 30px;
}

/* Job description styling for HTML content */
.job-description {
    word-wrap: break-word;
    line-height: 1.5;
}

::v-deep .rx-container {
    border-color: #B5B5B8 !important;
}

::v-deep .rx-editor-container {
    min-height: 170px;
}

::v-deep .rx-editor-container .rx-editor {
    min-height: 170px !important;
}

::v-deep .rx-toolbar-container.is-rx-toolbar {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border-color: #B5B5B8 !important;
}

::v-deep.job-description:not(:has(.rx-editor-container)) a {
    color: #0066cc !important;
    text-decoration: underline !important;
    font-weight: 600 !important;
}

::v-deep.job-description:not(:has(.rx-editor-container)) a:hover {
    color: #004499 !important;
}

::v-deep.job-description:not(:has(.rx-editor-container)) p {
    margin-bottom: 0px !important;
}

.job-description p {
    margin-bottom: 0.5rem;
}

.job-description p:last-child {
    margin-bottom: 0;
}

@media (max-width: 992px) {
    .job-details-container {
        padding-left: 16px;
        padding-right: 16px;
    }

    .account-nav {
        justify-content: center;
        background-color: #ffffff;
    }

    .dropdown-menu {
        box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
        box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12) !important;
        box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08) !important;
    }
}

</style>
